import {
  Button,
  Form,
  Input,
  Switch,
  Radio,
  Select,
  InputNumber,
  Tag,
  Upload,
  Row,
  Col,
  Divider,
  message,
} from 'antd'
import { InboxOutlined, UploadOutlined, PlusOutlined } from '@ant-design/icons'
import TextArea from 'antd/lib/input/TextArea'
import './newHouse.css'
import NewTags from './components/newTags/newTags'
import UploadPictures from './components/uploadPictures/uploadPictures'
import HouseComment from './components/houseComment/houseComment'
import { useEffect, useRef, useState } from 'react'
import { MyValidateMessages } from '../../utils/validateMessaage'
import { json, useLocation, useNavigate } from 'react-router-dom'
import { changeHouse, newHouse, uploadImg } from '../../api/api'
import UploadlistTypePicture from '../../components/uploadlistTypePicture/uploadlistTypePicture'
import UploadlistTypeMultiplePicture from '../../components/uploadlistTypeMultiplePicture/uploadlistTypeMultiplePicture'
import UploadVideo from '../../components/uploadVideo/uploadVideo'
import UploadHouseFirstImg from './components/uploadHouseFirstImg/uploadHouseFirstImg'
import UploadlistTypeVideo from '../../components/uploadlistTypeVideo/uploadlistTypeVideo'
import RoomDetail from './components/roomDetail/roomDetail'
import Title from 'antd/lib/skeleton/Title'
import UploadRoomsImage from './components/uploadRoomsImage/uploadRoomsImage'

export default function NewHouse() {
  const [newBasicInfo, setNewBasicInfo] = useState([])
  const [image, setImage] = useState({}) //房源首图
  const [video, setVideo] = useState('') //房源视频
  const [images, setImages] = useState([]) //房源图片
  const [roomsImage, setRoomsImage] = useState([]) //卧室房源图片
  const [currentRoomImage, setCurrentRoomImage] = useState([]) //当前正在处理的卧室图片
  const [locationImage, setLocationImage] = useState('') //地理位置图片
  const [contactImage, setContactImage] = useState('') //联系人图片
  const [comment, setComment] = useState([])
  const [isFresh, setIsFresh] = useState(false)
  const [form] = Form.useForm()
  const commentRef = useRef()
  const tagsRef = useRef()
  const location = useLocation()
  const { Option } = Select
  const info = location.state.info
  const layout = {
    labelCol: {
      span: 4,
    },
    wrapperCol: {
      span: 18,
    },
  }

  useEffect(() => {
    if (location.state.state === 'edit') {
      //图片的数据初始化还要再处理一下
      console.log('edit')
      // localStorage.setItem("isEdit","1")
      setImages(info.images)
      const roomsDetailImage = []
      info?.rooms_detail?.map((item, index) => {
        roomsDetailImage.push(item.images)
      })
      console.log('roomsDetailImage', roomsDetailImage)
      setRoomsImage(roomsDetailImage)
      setLocationImage(info.location_image)
      setContactImage(info.contact_image)
      setComment(info.evaluations)
      console.log('default value :', form.getFieldsValue())
    }
  }, [])

  const onFinish = (values) => {
    // values.evaluations =
    // console.log(form.getFieldValue('price'))
    // console.log("comment",comment);
    // console.log(comment)
    console.log(roomsImage)
    const newRoomsDetail = form.getFieldValue('rooms_detail')
      ? form.getFieldValue('rooms_detail').map((item, index) => {
          console.log('Finish roomsImage', roomsImage)
          item['images'] = roomsImage[index]
          return item
        })
      : []
    form.setFieldValue('image', image)
    form.setFieldValue('images', images)
    form.setFieldValue('location_image', locationImage)
    form.setFieldValue('contact_image', contactImage)
    form.setFieldValue('tags', tagsRef.current.tags)
    form.setFieldValue('video', video)
    form.setFieldValue('evaluations', comment)
    form.setFieldValue('rooms_detail', newRoomsDetail)

    form
      .validateFields()
      .then((data) => {
        //将boolen转化成数字
        data.is_recommend = data.is_recommend ? 1 : 0
        data.is_show = data.is_show ? 1 : 0
        // data.is_bills_included = 0
        //修改一些表单字段符合后端接口
        data.evaluations = comment
        data.customize_basic_information =
          data.customize_basic_information ?? []
        console.log('the form data is', data)
        if (location.state.state === 'edit') {
          const params = data
          data.id = info.id
          changeHouse(params).then((res) => {
            if (res.data.code === 0) {
              message.success('修改房源成功！')
              navigate('/houseManage')
            } else {
              message.error('修改房源失败，请稍后再试！')
            }
          })
        } else {
          newHouse(data)
            .then((res) => {
              if (res.data.code === 0) {
                message.success('新增房源成功！')
                navigate('/houseManage')
              } else {
                message.error('新增房源失败，请稍后再试！')
              }
            })
            .catch((err) => console.log('error', err))
        }
      })
      .catch((err) => {
        console.log(err)
        message.error('未完成所有必填项！')
      })
    // console.log('the form is', values)
  }

  //上传组件
  const normFile = (e) => {
    console.log('Upload event:', e)
    if (Array.isArray(e)) {
      return e
    }
    return e?.fileList
  }

  const mySubmit = (e) => {
    console.log('begin submit', e)
    const image = {
      image: e.file,
    }
    uploadImg(e).then((res) => {
      console.log(res)
    })
  }

  //管理基本信息选填
  const add = () => {
    setNewBasicInfo([...newBasicInfo, {}])
  }

  const deleteContent = (idx) => {
    newBasicInfo.map((info, index) => {
      if (index === idx) {
        newBasicInfo.splice(idx, 1)
        setNewBasicInfo(() => {
          return [...newBasicInfo]
        })
        console.log('delete:', info)
      }
    })
  }

  //取消提交
  const navigate = useNavigate()

  const cancelSubmit = () => {
    navigate('/houseManage')
  }

  useEffect(() => {
    console.log('refresh!')
  }, [isFresh])
  return (
    <div className="newHouse">
      <p className="newHouseTitle">房源信息</p>
      <div>
        <Form
          form={form}
          {...layout}
          layout={'horizontal'}
          name="nest-messages"
          // onFinish={onFinish}
          initialValues={info ?? {}}
          validateMessages={MyValidateMessages}
        >
          <Row>
            <Col span={12}>
              {/* 房源标题 */}
              <Form.Item
                label="房源标题"
                name="title"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input placeholder="上限20字" />
              </Form.Item>
            </Col>

            <Col span={12}>
              {/* 房源编号 */}
              <Form.Item
                label="房源编号"
                name="sn"
                rules={[
                  {
                    required: true,
                    max: 10,
                  },
                ]}
              >
                <Input placeholder="上限10字" />
              </Form.Item>
            </Col>

            <Col span={12}>
              {/* 优先级 */}
              <Form.Item
                label="优先级"
                name="priority"
                rules={[
                  {
                    type: 'number',
                    required: true,
                    min: 0,
                    max: 99,
                  },
                ]}
              >
                <InputNumber
                  style={{ width: '150px' }}
                  placeholder="输入0-99的整数"
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              {/* 租金 */}
              {/* <Form.Item label="租金" >
                <span className="ant-form-text">£</span>
                <Form.Item
                  name="price"
                  noStyle
                  style={{ width: '200px' }}
                  placeholder="请填写租金"
                  rules={[
                    {
                      type: 'number',
                      required: true,
                    },
                  ]}
                >
                  <InputNumber />
                </Form.Item>
                <span className="ant-form-text"> /周</span>
              </Form.Item> */}
              <Form.Item label="最低租金">
                {' '}
                <span className="ant-form-text">£</span>
                <Form.Item
                  noStyle
                  name="price"
                  rules={[
                    {
                      type: 'number',
                      required: true,
                    },
                  ]}
                >
                  <InputNumber
                    noStyle
                    style={{ width: '200px' }}
                    placeholder="请填写租金（必填项）"
                  />
                </Form.Item>
                <span className="ant-form-text"> /周</span>
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                label="房源类型"
                hasFeedback
                name="type"
                rules={[
                  {
                    required: true,
                    message: '请选择房源类型',
                  },
                ]}
              >
                <Select placeholder="请选择">
                  <Select.Option value={1}>超豪华别墅</Select.Option>
                  <Select.Option value={2}>距学校超级近</Select.Option>
                  <Select.Option value={3}>超高性价比</Select.Option>
                </Select>
              </Form.Item>
            </Col>

            <Col span={12}>
              {/* 区域 */}
              <Form.Item
                label="区域"
                name="regions"
                hasFeedback
                // defaultValue={location.state.info.regions}
                rules={[
                  {
                    required: true,
                    message: '请选择区域',
                  },
                ]}
              >
                <Select placeholder="请选择" mode="multiple">
                  <Option value={1}>Cannon Park Region</Option>
                  <Option value={2}>Charter Avenue</Option>
                  <Option value={3}>Sir Henry Parkes Road</Option>
                  <Option value={4}>White Willow Park</Option>
                  <Option value={5}>Torrington Avenue</Option>
                  <Option value={6}>其他</Option>
                </Select>
              </Form.Item>
            </Col>

            <Col span={12}>
              {/* 地址与邮编 */}
              <Form.Item
                label="地址与邮编"
                name="address"
                rules={[
                  {
                    required: true,
                    max: 50,
                  },
                ]}
              >
                <Input placeholder="上限50字" />
              </Form.Item>
            </Col>
            <Col span={10} offset={1}>
              {/* 租金 */}
              <Form.Item>
                <span style={{ color: 'red', marginLeft: 15 }}>*</span>
                <span>热度：</span>
                <Form.Item
                  name="hotness"
                  noStyle
                  style={{ width: '200px' }}
                  placeholder="请填写租金"
                  rules={[
                    {
                      type: 'number',
                      required: true,
                    },
                  ]}
                >
                  <InputNumber />
                </Form.Item>
                <span className="ant-form-text">人正在看</span>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={7}>
              {/* 推荐状态 */}
              <Form.Item
                labelCol={{ span: 7 }}
                label="推荐状态"
                valuePropName="checked"
                name="is_recommend"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Switch
                  checkedChildren="推荐"
                  unCheckedChildren="未推荐"
                  defaultChecked={info?.is_recommend ?? 0 === 0 ? false : true}
                />
              </Form.Item>
            </Col>

            <Col span={7}>
              {/* 上架状态 */}
              <Form.Item
                labelCol={{ span: 7 }}
                label="上架状态"
                name="is_show"
                valuePropName="checked"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Switch
                  checkedChildren="已上架"
                  unCheckedChildren="未上架"
                  defaultChecked={info?.is_recommend ?? 0 === 0 ? false : true}
                />
              </Form.Item>
            </Col>

            <Col span={7}>
              {/* 房屋数量 废弃！ */}
              {/* <Form.Item
                labelCol={{ span: 7 }}
                name="rooms_actual"
                label="房间数量"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select placeholder="请选择房间数量">
                  <Select.Option value={1}>1</Select.Option>
                  <Select.Option value={2}>2</Select.Option>
                  <Select.Option value={3}>3</Select.Option>
                  <Select.Option value={4}>4</Select.Option>
                  <Select.Option value={5}>5</Select.Option>
                  <Select.Option value={6}>6</Select.Option>
                  <Select.Option value={7}>7</Select.Option>
                  <Select.Option value={8}>8</Select.Option>
                  <Select.Option value={9}>9</Select.Option>
                </Select>
              </Form.Item> */}
            </Col>
          </Row>

          {/* 标签 */}
          <Form.Item labelCol={{ span: 2 }} label="标签" name="tags">
            <NewTags ref={tagsRef} tags={info?.tags ?? []} />
          </Form.Item>

          <Row>
            <Col span={12}>
              {/* 已订量 (仅展示）*/}
              <Form.Item label="已订量">
                {info?.rooms_remaining + '/' + info?.rooms_actual}
              </Form.Item>

              {/* 房源首图 */}
              <Form.Item
                label="房源首图"
                name="image"
                valuePropName="fileList"
                getValueFromEvent={normFile}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <UploadHouseFirstImg
                  deliverUrl={setImage}
                  image={info?.image?.thumbnail ?? ''}
                />
              </Form.Item>

              {/* 房源视频 */}
              <Form.Item
                label="房源视频"
                name="video"
                valuePropName="fileList"
                getValueFromEvent={normFile}
              >
                <UploadlistTypeVideo
                  video={info?.video ?? ''}
                  id={info?.id ?? ''}
                  deliverUrl={setVideo}
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              {/* 房源信息选填项 */}
              <Form.Item
                label="房源信息选填项"
                labelCol={{ span: 5, pull: 1 }}
                name={['customize_key_information', 0, 'name']}
                rules={[
                  {
                    max: 10,
                  },
                ]}
              >
                <Input placeholder="请填写标题，上限10个字" />
              </Form.Item>
              <Form.Item
                name={['customize_key_information', 0, 'content']}
                rules={[
                  {
                    max: 20,
                  },
                ]}
              >
                <Input
                  style={{
                    marginLeft: '28%',
                  }}
                  placeholder="请填写内容，上限20个字"
                />
              </Form.Item>
            </Col>
          </Row>
          {/* 房源图片 */}
          <Form.Item
            label="房源图片"
            labelCol={{ span: 2 }}
            name="images"
            rules={[{ required: true }]}
          >
            <UploadlistTypeMultiplePicture
              max={30}
              name="房源图片"
              deliverUrl={setImages}
              images={info?.images ?? []}
            />
          </Form.Item>
          {/* 地理位置图片 */}
          <Form.Item
            label="位置图片"
            labelCol={{ span: 2 }}
            name="location_image"
            rules={[{ required: true }]}
          >
            <UploadlistTypePicture
              imageName="地理位置图片"
              deliverUrl={setLocationImage}
              image={info?.location_image ?? ''}
            />
          </Form.Item>
          {/* 房屋设备（废弃！） */}
          {/* <Form.Item
            label="房屋设备"
            labelCol={{ span: 2 }}
            name="devices"
            rules={[{ type: 'string', required: true, max: 50 }]}
          >
            <TextArea placeholder="请填写内容，上限50字" />
          </Form.Item> */}
          {/* 是否包含bills（废弃！） */}
          {/* <Form.Item
            label="是否包含bills"
            labelCol={{ span: 3, pull: 1 }}
            wrapperCol={{ span: 8, pull: 1 }}
            name="is_bills_included"
            rules={[
              {
                required: true,
                max: 10,
              },
            ]}
          >
            <Input placeholder="请填写内容，上限10个字" />
          </Form.Item> */}

          {/* 基本信息选填 */}
          <Divider style={{ padding: 20 }} orientation="left">
            基本信息选填
          </Divider>
          <Form.List name="customize_basic_information">
            {(fields, { remove, add, move }) => {
              // console.log(fields)
              return (
                <>
                  {fields.map((field, index) => (
                    <div key={index} style={{ width: '1200px' }}>
                      <Row>
                        <Col span={20}>
                          <Form.Item
                            labelCol={{ span: 4 }}
                            label={'基本信息选填项' + Number(index + 1)}
                            name={[field.name, 'name']}
                            rules={[
                              {
                                max: 10,
                              },
                            ]}
                          >
                            <Input
                              placeholder="请填写标题，上限10字"
                              style={{ width: '800px' }}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={4}>
                          <div
                            style={{ cursor: 'pointer', color: '#1890ff' }}
                            onClick={
                              () => remove(index)
                              // deleteContent(index)
                            }
                          >
                            删除
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col span={20}>
                          <Form.Item
                            labelCol={{ span: 4 }}
                            label={'选填项' + Number(index + 1) + '内容'}
                            name={[field.name, 'content']}
                            rules={[
                              {
                                max: 50,
                              },
                            ]}
                          >
                            <Input
                              placeholder="请填写内容，上限50字"
                              style={{ width: '800px' }}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Divider />
                    </div>
                  ))}

                  <Form.Item className={'text-center'}>
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      block
                      icon={<PlusOutlined />}
                      style={{ width: '900px', marginLeft: '100px' }}
                    >
                      新增基础信息选填项
                    </Button>
                  </Form.Item>
                </>
              )
            }}
          </Form.List>

          <Divider style={{ padding: 20 }} orientation="left">
            卧室信息
          </Divider>

          {/* 卧室信息 */}
          <Form.List
            name="rooms_detail"
            // initialValue={[1, 2, 3]}
          >
            {(fields, { remove, add, move }) => {
              return (
                <>
                  {/* 把它当成正常表单数据，图片不作为表单的一部分，将它存入一个单独的数组，等到上传数据的时候再把图片添加到数据中，
                在删除操作的时候记得维护数组
                */}
                  {fields.map((field, index) => (
                    <>
                      <h1 style={{ color: '#1e80ff' }}>
                        {'ROOM ' + (index + 1)}
                      </h1>
                      <Row>
                        <Col span={8}>
                          <Form.Item
                            label={'名称'}
                            name={[field.name, 'name']}
                            rules={[
                              {
                                required: true,
                                max: 30,
                              },
                            ]}
                          >
                            <Input placeholder="请输入该卧室名称，上限30字" />
                          </Form.Item>
                        </Col>

                        <Col span={8}>
                          <Form.Item
                            label={'租订情况'}
                            labelCol={{ span: 8 }}
                            rules={[
                              {
                                required: true,
                              },
                            ]}
                            name={[field.name, 'is_available']}
                          >
                            <Radio.Group block>
                              <Radio value={1}> 已订 </Radio>
                              <Radio value={0}> 未订 </Radio>
                            </Radio.Group>
                          </Form.Item>
                        </Col>

                        <Col span={7}>
                          <Form.Item label="租金">
                            {' '}
                            <span className="ant-form-text">£</span>
                            <Form.Item
                              noStyle
                              name={[field.name, 'price']}
                              rules={[
                                {
                                  type: 'number',
                                  required: true,
                                },
                              ]}
                            >
                              <InputNumber
                                noStyle
                                style={{ width: '200px' }}
                                placeholder="0 - 999 的整数"
                              />
                            </Form.Item>
                            <span className="ant-form-text"> /周</span>
                          </Form.Item>
                        </Col>

                        <Col>
                          <div
                            style={{
                              cursor: 'pointer',
                              color: '#1890ff',
                              padding: 5,
                            }}
                            onClick={
                              () => {
                                remove(index)
                                setRoomsImage((pre) => {
                                  pre.splice(index, 1)
                                  return pre
                                })
                                // setIsFresh((pre) => !pre)
                              }
                              // deleteContent(index)
                            }
                          >
                            删除
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col span={24}>
                          <h3>设备</h3>
                        </Col>
                        <Col span={11}>
                          <Form.Item
                            label={'床铺信息'}
                            name={[field.name, 'bed_info']}
                            rules={[
                              {
                                max: 8,
                                required: true,
                              },
                            ]}
                          >
                            <Input placeholder="上限8字" />
                          </Form.Item>
                        </Col>

                        <Col span={1}></Col>

                        <Col span={11}>
                          <Form.Item
                            label={'卧室面积'}
                            name={[field.name, 'area']}
                            rules={[
                              {
                                max: 8,
                                required: true,
                              },
                            ]}
                          >
                            <Input placeholder="上限8字" />
                          </Form.Item>
                        </Col>

                        <Col span={11}>
                          <Form.Item
                            label={'是否独立卫浴'}
                            labelCol={12}
                            name={[field.name, 'is_toilet_separate']}
                            rules={[
                              {
                                max: 8,
                                required: true,
                              },
                            ]}
                          >
                            <Input placeholder="上限8字" />
                          </Form.Item>
                        </Col>

                        <Col span={1}></Col>

                        <Col span={11}>
                          <Form.Item
                            label={'厨房情况'}
                            name={[field.name, 'kitchen_condition']}
                            rules={[
                              {
                                max: 8,
                                required: true,
                              },
                            ]}
                          >
                            <Input placeholder="上限8字" />
                          </Form.Item>
                        </Col>

                        <Col span={11}>
                          <Form.Item
                            label={'是否包含bills '}
                            labelCol={12}
                            name={[field.name, 'is_bills_included']}
                            rules={[
                              {
                                max: 8,
                                required: true,
                              },
                            ]}
                          >
                            <Input placeholder="上限8字" />
                          </Form.Item>
                        </Col>

                        <Col span={1}></Col>

                        <Col span={11}>
                          <Form.Item
                            label={'租期'}
                            name={[field.name, 'period']}
                            rules={[
                              {
                                max: 8,
                                required: true,
                              },
                            ]}
                          >
                            <Input placeholder="上限8字" />
                          </Form.Item>
                        </Col>
                      </Row>
                      {/* 房源图片 */}
                      <Form.Item
                        label="房源图片"
                        labelCol={{ span: 2 }}
                        key={'rooms_detail_image' + index}
                      >
                        <UploadRoomsImage
                          max={30}
                          name="房间图片"
                          roomIndex={index}
                          deliverUrl={setRoomsImage}
                          images={info?.rooms_detail?.[index]?.images ?? []}
                        />
                      </Form.Item>

                      <Divider />
                    </>
                  ))}

                  <Form.Item className={'text-center'}>
                    <Button
                      type="dashed"
                      onClick={() => {
                        const rooms_detail = form.getFieldValue('rooms_detail')
                        add(
                          rooms_detail?.length - 1
                            ? rooms_detail[rooms_detail.length - 1]
                            : null
                        )
                        // add()
                        console.log(form.getFieldValue('rooms_detail'))
                        setRoomsImage((pre) => {
                          pre.push([])
                          return pre
                        })
                      }}
                      block
                      icon={<PlusOutlined />}
                      style={{ width: '900px', marginLeft: '100px' }}
                    >
                      新增卧室
                    </Button>
                  </Form.Item>
                </>
              )
            }}
          </Form.List>

          {/* 联系方式 */}
          {/* <Form.Item labelCol={{ span: 2 }} style={{ marginBottom: 0 }}> */}
          <Row>
            <Col span={12}>
              <Form.Item
                name="contact"
                label="联系方式"
                style={{ margin: '10px 0' }}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input placeholder="联系方式的文字填写框、图片上传项都是必填。" />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                name="contact_image"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <UploadlistTypePicture
                  imageName="联系人方式图片"
                  deliverUrl={setContactImage}
                  image={info?.contact_image ?? ''}
                />
              </Form.Item>
            </Col>
          </Row>

          {/* </Form.Item> */}

          {/* 房源详情介绍 */}
          <Form.Item
            labelCol={{ span: 3, pull: 1 }}
            wrapperCol={{ pull: 1 }}
            name="detail"
            label="房源详情介绍"
            rules={[
              {
                required: true,
                max: 5000,
              },
            ]}
          >
            <TextArea />
          </Form.Item>
          {/* 评论 */}
          <Divider />
          <p className="newHouseTitle">广告信息</p>
          <Row>
            <Col style={{ marginLeft: 20 }} span={6}>
              {/* 是否独卫 */}
              <Form.Item
                name="is_toilet_separate"
                label="是否独卫"
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 12 }}
              >
                <Select
                  defaultValue={info?.is_toilet_separate}
                  style={{ width: 150 }}
                  allowClear
                  options={[
                    {
                      value: 1,
                      label: '独卫',
                    },
                    {
                      value: 0,
                      label: '非独卫',
                    },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col>
              {/* 是否包bill */}
              <Form.Item name="is_bills_covered" label="是否包bill">
                <Select
                  defaultValue={info?.is_bills_covered}
                  style={{ width: 150 }}
                  allowClear
                  options={[
                    {
                      value: 1,
                      label: '是',
                    },
                    {
                      value: 0,
                      label: '否',
                    },
                  ]}
                />
              </Form.Item>
            </Col>
          </Row>
          {/* 步行到学校的距离 */}
          <Form.Item
            name="distance"
            label="步行到学校的距离"
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Select
              defaultValue={info?.distance}
              style={{ width: 400 }}
              allowClear
              options={[
                {
                  value: 1,
                  label: '步行15分钟以内',
                },
                {
                  value: 2,
                  label: '步行20分钟以内或者公共交通10分钟以内',
                },
                {
                  value: 3,
                  label: '步行30分钟以内或者公共交通20分钟以内',
                },
                {
                  value: 4,
                  label: '公共交通35分钟以内',
                },
              ]}
            />
          </Form.Item>
          {/* </Col>
          </Row> */}
          <Divider />
          <p className="newHouseTitle">房源评价</p>
          <HouseComment
            ref={commentRef}
            setComment={setComment}
            data={info?.evaluations ?? []}
          />
          <Form.Item
          // wrapperCol={{
          //   offset: 11,
          // }}
          >
            {/* <Button type="primary" htmlType="submit" className="submitButton">
              提交
            </Button> */}
            <div>
              {/* <div className='buttonGroupBackgroundColor'></div> */}
              <div className="buttonGroup">
                <Button onClick={cancelSubmit}>取消</Button>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ marginLeft: '20px' }}
                  onClick={onFinish}
                >
                  提交
                </Button>
              </div>
            </div>
          </Form.Item>
        </Form>
      </div>
    </div>
  )
}
